export const SET_FEEDBACK_GROUP = "SET_FEEDBACK_GROUP";
export const POST_FEEDBACK = "POST_FEEDBACK";
export const POST_FEEDBACK_UPDATE = "POST_FEEDBACK_UPDATE";
export const CACHE_FEEDBACK = "CACHE_FEEDBACK";
export const LOAD_FEEDBACKS = "LOAD_FEEDBACKS";
export const SET_DATE = "SET_DATE";
export const REMOVE_CACHED_FEEDBACK = "REMOVE_CACHED_FEEDBACK";
export const UPDATE_PERCENT_UPLOADED = "UPDATE_PERCENT_UPLOADED";
export const SET_FEEDBACK_STATUS = "SET_FEEDBACK_STATUS";
export const SET_FEEDBACK_REVIEW = "SET_FEEDBACK_REVIEW";
export const GET_FEEDBACK_REVIEW = "GET_FEEDBACK_REVIEW";
export const SET_IS_REVIEW_RECEIVED = "SET_IS_REVIEW_RECEIVED";
export const SET_SELECTED_FEEDBACK_OPTIONS = "SET_SELECTED_FEEDBACK_OPTIONS";
